import { transmissionAnalyticAction } from "app/store/dashboard/transmission_analytic/actions/transmissionAnalyticAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accountFilter: "",
  startDate: "",
  endDate: "",
};

const transmissionAnalyticSlice = createSlice({
  name: "transmissionAnalytic",
  initialState: initialState,
  reducers: transmissionAnalyticAction,
});

export const { changeFilter } = transmissionAnalyticSlice.actions;

export default transmissionAnalyticSlice.reducer;
